import * as Sentry from '@sentry/browser';
import { user } from 'app/user';

// Don't load sentry in local development to avoid HMR CORS errors
if (SENTRY_DSN && !APP_DEBUG) {
    Sentry.init({
        dsn: SENTRY_DSN,
        environment: APP_ENVIRONMENT,
        release: APP_RELEASE,
        allowUrls: [
            /.*\.karriere\.at/,
            /kcdn\.at/,
        ],
        integrations: [
            Sentry.browserTracingIntegration(),
        ],
        tracePropagationTargets: [
            'localhost',
            'k4.test',
            'kcdn.at',
            /^\//,
            // Match all karriere.at origins except `gtm.karriere.at`.
            // If you want to exclude other subdomains you can do it
            // with a regular expression like this:
            // `/^((?!gtm|other\.).)*karriere.at.*$/`
            /^((?!gtm\.).)*karriere.at.*$/,
        ],
        tracesSampleRate: SENTRY_TRACES_SAMPLE_RATE,
        ignoreErrors: ['ResizeObserver loop limit exceeded'],
    });

    Sentry.setTag('source', 'js');
    const userUuid = user.getUserUuid();
    if (userUuid) Sentry.setUser({ id: userUuid });
}
